<!-- Page 1 -->
<div class="pdf-page app-cp-00-17-10-12" id="cp171012">
  <div class="t-right p-5">
    <p class="font-small mb-0"><b>COMMERCIAL PROPERTY</b></p>
    <p class="font-small"><b>CP 00 17 10 12</b></p>
  </div>
  <div>
    <p class="font-large mb-0" style="text-align: center">
      <b>CONDOMINIUM ASSOCIATION COVERAGE FORM</b>
    </p>
    <div class="font-small">
      <p>
        Various provisions in this policy restrict coverage. Read the entire
        policy carefully to determine rights, duties and what is and is not
        covered.
      </p>
      <p>
        Throughout this policy, the words "you" and "your" refer to the Named
        Insured shown in the Declarations. The words "we", "us" and "our" refer
        to the company providing this insurance.
      </p>
      <p>
        Other words and phrases that appear in quotation marks have special
        meaning. Refer to Section <b>H.</b> Definitions.
      </p>
    </div>
    <table style="width: 100%" class="font-small">
      <tbody>
        <tr>
          <!-- Left -->
          <td style="width: 50%">
            <ol type="A">
              <li style="padding-bottom: 10px;">
                <b> Coverage </b><br />
                We will pay for direct physical loss of or damage to Covered
                Property at the premises described in the Declarations caused by
                or resulting from any Covered Cause of Loss.
                <ol>
                  <li style="padding-bottom: 10px;">
                    <b>Covered Property</b><br />
                    Covered Property, as used in this Coverage Part, means the
                    type of property described in this section,
                    <b>A.1.,</b> and limited in <b>A.2.</b> Property Not
                    Covered, if a Limit Of Insurance is shown in the
                    Declarations for that type of property.
                    <ol type="a">
                      <li style="padding-bottom: 10px;">
                        <b>Building,</b> meaning the building or structure
                        described in the Declarations, including:
                        <ul style="list-style-type: none">
                          <li style="padding-bottom: 10px;"><b>(1)</b> Completed additions;</li>
                          <li style="padding-bottom: 10px;">
                            <b>(2)</b> Fixtures, outside of individual units,
                            including outdoor fixtures;
                          </li>
                          <li style="padding-bottom: 10px;">
                            <b>(3)</b> Permanently installed:
                            <ul style="list-style-type: none">
                              <li style="padding-bottom: 10px;"><b>(a)</b> Machinery; and</li>
                              <li style="padding-bottom: 10px;"><b>(b)</b> Equipment;</li>
                            </ul>
                          </li>
                          <li style="padding-bottom: 10px;">
                            <b>(4)</b> Personal property owned by you that is
                            used to maintain or service the building or
                            structure or its premises, including:
                            <ul style="list-style-type: none">
                              <li style="padding-bottom: 10px;"><b>(a)</b> Fire-extinguishing equipment;</li>
                              <li style="padding-bottom: 10px;"><b>(b)</b> Outdoor furniture;</li>
                              <li style="padding-bottom: 10px;"><b>(c)</b> Floor coverings; and</li>
                              <li style="padding-bottom: 10px;">
                                <b>(d)</b> Appliances used for refrigerating,
                                ventilating, cooking, dishwashing or laundering
                                that are not contained within individual units;
                              </li>
                            </ul>
                          </li>
                          <li style="padding-bottom: 10px;">
                            <b>(5)</b> If not covered by other insurance:
                            <ul style="list-style-type: none">
                              <li style="padding-bottom: 10px;">
                                <b>(a)</b> Additions under construction,
                                alterations and repairs to the building or
                                structure;
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </td>
          <!-- Right -->
          <td style="width: 50%; vertical-align: top">
            <ul style="list-style-type: none">
              <li style="padding-bottom: 10px;">
                <ul style="list-style-type: none">
                  <li style="padding-bottom: 10px;">
                    <b>(b)</b> Materials, equipment, supplies and temporary
                    structures, on or within 100 feet of the described premises,
                    used for making additions, alterations or repairs to the
                    building or structure.
                  </li>
                </ul>
                <b>(6)</b> Any of the following types of property contained
                within a unit, regardless of ownership, if your Condominium
                Association Agreement requires you to insure it:
                <ul style="list-style-type: none">
                  <li style="padding-bottom: 10px;">
                    <b>(a) </b>Fixtures, improvements and alterations that are a
                    part of the building or structure; and
                  </li>
                  <li style="padding-bottom: 10px;">
                    <b>(b) </b>Appliances, such as those used for refrigerating,
                    ventilating, cooking, dishwashing, laundering, security or
                    housekeeping.
                  </li>
                </ul>
                But Building does not include personal property owned by, used
                by or in the care, custody or control of a unit-owner except for
                personal property listed in Paragraph
                <b>A.1.a.(6)</b> above.
              </li>
            </ul>

            <ol type="a" start="2">
              <li style="padding-bottom: 10px;">
                <b>Your Business Personal Property</b> y located in or on the
                building or structure described in the Declarations or in the
                open (or in a vehicle) within 100 feet of the described
                premises, consisting of the following:
                <ul style="list-style-type: none">
                  <li style="padding-bottom: 10px;">
                    <b>(1)</b> Personal property owned by you or owned
                    indivisibly by all unit-owners;
                  </li>
                  <li style="padding-bottom: 10px;">
                    <b>(2)</b> Your interest in the labor, materials or services
                    furnished or arranged by you on personal property of others;
                    and
                  </li>
                  <li style="padding-bottom: 10px;">
                    <b>(3)</b> Leased personal property for which you have a
                    contractual responsibility to insure, unless otherwise
                    provided for under Personal Property Of Others.
                  </li>
                </ul>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<!-- Page 2 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  But Your Business Personal Property does not include personal
                  property owned only by a unit-owner.
                </li>
              </ul>
              <ol type="a" start="3">
                <li style="padding-bottom: 10px;">
                  <b>Personal Property Of Others</b> that is:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;"><b>(1) </b>In your care, custody or control; and</li>
                    <li style="padding-bottom: 10px;">
                      <b>(2) </b>Located in or on the building or structure
                      described in the Declarations or in the open (or in a
                      vehicle) within 100 feet of the described premises.
                    </li>
                  </ul>
                  <p>
                    However, our payment for loss of or damage to personal
                    property of others will only be for the account of the owner
                    of the property.
                  </p>
                </li>
              </ol>
            </li>
          </ul>
          <ol type="1" start="2">
            <li style="padding-bottom: 10px;">
              <b>Property Not Covered</b><br />
              Covered Property does not include:
              <ol type="a">
                <li style="padding-bottom: 10px;">
                  Accounts, bills, currency, food stamps or other evidences of
                  debt, money, notes or securities. Lottery tickets held for
                  sale are not securities;
                </li>
                <li style="padding-bottom: 10px;">
                  Animals, unless owned by others and boarded by you, or if
                  owned by you;
                </li>
                <li style="padding-bottom: 10px;">Automobiles held for sale;</li>
                <li style="padding-bottom: 10px;">
                  Bridges, roadways, walks, patios or other paved surfaces;
                </li>
                <li style="padding-bottom: 10px;">
                  Contraband, or property in the course of illegal
                  transportation or trade;
                </li>
                <li style="padding-bottom: 10px;">
                  The cost of excavations, grading, backfilling or filling;
                </li>
                <li style="padding-bottom: 10px;">
                  Foundations of buildings, structures, machinery or boilers if
                  their foundations are below:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;"><b>(1)</b> The lowest basement floor; or</li>
                    <li style="padding-bottom: 10px;">
                      <b>(2)</b> The surface of the ground, if there is no
                      basement;
                    </li>
                  </ul>
                </li>
                <li style="padding-bottom: 10px;">
                  Land (including land on which the property is located), water,
                  growing crops or lawns (other than lawns which are part of a
                  vegetated roof);
                </li>
                <li style="padding-bottom: 10px;">Personal property while airborne or waterborne;</li>
                <li style="padding-bottom: 10px;">Bulkheads, pilings, piers, wharves or docks;</li>
                <li style="padding-bottom: 10px;">
                  Property that is covered under this or any other policy in
                  which it is more specifically described, except for the excess
                  of the amount due (whether you can collect on it or not) from
                  that other insurance;
                </li>
                <li style="padding-bottom: 10px;">Retaining walls that are not part of a building;</li>
                <li style="padding-bottom: 10px;">Underground pipes, flues or drains;</li>
              </ol>
            </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ol type="a" start="14">
            <li style="padding-bottom: 10px;">
              Electronic data, except as provided under the Additional Coverage,
              Electronic Data. Electronic data means information, facts or
              computer programs stored as or on, created or used on, or
              transmitted to or from computer software (including systems and
              applications software), on hard or floppy disks, CD-ROMs, tapes,
              drives, cells, data processing devices or any other repositories
              of computer software which are used with electronically controlled
              equipment. The term computer programs, referred to in the
              foregoing description of electronic data, means a set of related
              electronic instructions which direct the operations and functions
              of a computer or device connected to it, which enable the computer
              or device to receive, process, store, retrieve or send data. This
              paragraph, <b>n.,</b> does not apply to electronic data which is
              integrated in and operates or controls the building's elevator,
              lighting, heating, ventilation, air conditioning or security
              system;
            </li>
            <li style="padding-bottom: 10px;">
              The cost to replace or restore the information on valuable papers
              and records, including those which exist as electronic data.
              Valuable papers and records include but are not limited to
              proprietary information, books of account, deeds, manuscripts,
              abstracts, drawings and card index systems. Refer to the Coverage
              Extension for Valuable Papers And Records (Other Than Electronic
              Data) for limited coverage for valuable papers and records other
              than those which exist as electronic data;
            </li>
            <li style="padding-bottom: 10px;">
              Vehicles or self-propelled machines (including aircraft or
              watercraft) that:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;"><b>(1)</b> Are licensed for use on public roads; or</li>
                <li style="padding-bottom: 10px;">
                  <b>(2)</b> Are operated principally away from the described
                  premises.
                </li>
                This paragraph does not apply to:
                <ul style="list-style-type: none">
                  <li style="padding-bottom: 10px;">
                    <b>(a)</b>Vehicles or self-propelled machines or autos you
                    manufacture or warehouse;
                  </li>
                  <li style="padding-bottom: 10px;">
                    <b>(b)</b>
                    Vehicles or self-propelled machines, other than autos, you
                    hold for sale;
                  </li>
                  <li style="padding-bottom: 10px;">
                    <b>(c)</b>
                    Rowboats or canoes out of water at the described premises;
                    or
                  </li>
                  <li style="padding-bottom: 10px;">
                    <b>(d)</b>
                    Trailers, but only to the extent provided for in the
                    Coverage Extension for Non-owned Detached Trailers; or
                  </li>
                </ul>
              </ul>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 3 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              q. The following property while outside of buildings:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;"><b>(1)</b> Grain, hay, straw or other crops;</li>
                <li style="padding-bottom: 10px;">
                  <b>(2)</b> Fences, radio or television antennas (including
                  satellite dishes) and their lead-in wiring, masts or towers,
                  trees, shrubs or plants (other than trees, shrubs or plants
                  which are "stock" or are part of a vegetated roof), all except
                  as provided in the Coverage Extensions.
                </li>
              </ul>
            </li>
          </ul>
          <ol>
            <li style="padding-bottom: 10px;">
              <b>Additional Coverages</b>
              <ol type="a">
                <li style="padding-bottom: 10px;">
                  <b>Debris Removal</b>
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(1)</b> Subject to Paragraphs <b>(2), (3)</b> and
                      <b>(4),</b> we will pay your expense to remove debris of
                      Covered Property and other debris that is on the described
                      premises, when such debris is caused by or results from a
                      Covered Cause of Loss that occurs during the policy
                      period. The expenses will be paid only if they are
                      reported to us in writing within 180 days of the date of
                      direct physical loss or damage.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(2)</b> Debris Removal does not apply to costs to:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px;">
                          <b>(a) </b> Remove debris of property of yours that is
                          not insured under this policy, or property in your
                          possession that is not Covered Property;
                        </li>
                        <li style="padding-bottom: 10px;">
                          <b>(b) </b> Remove any property that is Property Not
                          Covered, including property addressed under the
                          Outdoor Property Coverage Extension;
                        </li>
                        <li style="padding-bottom: 10px;">
                          <b>(c) </b> Remove property of others of a type that
                          would not be Covered Property under this Coverage
                          Form;
                        </li>
                        <li style="padding-bottom: 10px;">
                          <b>(d) </b>Remove deposits of mud or earth from the
                          grounds of the described premises;
                        </li>
                        <li style="padding-bottom: 10px;">
                          <b>(e) </b>Extract "pollutants" from land or water; or
                        </li>
                        <li style="padding-bottom: 10px;">
                          <b>(f) </b>Remove, restore or replace polluted land or
                          water
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <b>(3)</b> Subject to the exceptions in Paragraph <b>(4),</b> the
              following provisions apply:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(a)</b> The most we will pay for the total of direct
                  physical loss or damage plus debris removal expense is the
                  Limit of Insurance applicable to the Covered Property that has
                  sustained loss or damage.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(b)</b> Subject to <b>(a)</b> above, the amount we will pay
                  for debris removal expense is limited to 25% of the sum of the
                  deductible plus the amount that we pay for direct physical
                  loss or damage to the Covered Property that has sustained loss
                  or damage. However, if no Covered Property has sustained
                  direct physical loss or damage, the most we will pay for
                  removal of debris of other property (if such removal is
                  covered under this Additional Coverage) is $5,000 at each
                  location.
                </li>
              </ul>
            </li>
            <li style="padding-bottom: 10px;">
              <b>(4)</b> We will pay up to an additional $25,000 for debris
              removal expense, for each location, in any one occurrence of
              physical loss or damage to Covered Property, if one or both of the
              following circumstances apply:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(a)</b> The total of the actual debris removal expense plus
                  the amount we pay for direct physical loss or damage exceeds
                  the Limit of Insurance on the Covered Property that has
                  sustained loss or damage.
                </li>
                <li style="padding-bottom: 10px;">
                  <b> (b)</b> The actual debris removal expense exceeds 25% of
                  the sum of the deductible plus the amount that we pay for
                  direct physical loss or damage to the Covered Property that
                  has sustained loss or damage
                </li>
              </ul>
              Therefore, if <b>(4)(a)</b> and/or <b>(4)(b)</b> applies, our
              total payment for direct physical loss or damage and debris
              removal expense may reach but will never exceed the Limit of
              Insurance on the Covered Property that has sustained loss or
              damage, plus $25,000.
            </li>
            <li style="padding-bottom: 10px;">
              <b>(5)</b>
              Examples The following examples assume that there is no
              Coinsurance penalty.
            </li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 4 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%">
          <p><b>Example 1</b></p>
          <table style="width: 100%">
            <tbody>
              <tr>
                <td>Limit of Insurance</td>
                <td>$ 90,000</td>
              </tr>
              <tr>
                <td>Amount of Deductible</td>
                <td>$ 500</td>
              </tr>
              <tr>
                <td>Amount of Loss</td>
                <td>$ 50,000</td>
              </tr>
              <tr>
                <td>Amount of Loss Payable</td>
                <td>
                  $ 49,500 <br />
                  <span>($50,000 - $500)</span>
                </td>
              </tr>
              <tr>
                <td>Debris Removal Expense</td>
                <td>$ 10,000</td>
              </tr>
              <tr>
                <td>Debris Removal Expense Payable</td>
                <td>$ 10,000</td>
              </tr>
              <tr>
                <td>($10,000 is 20% of $50,000.)</td>
              </tr>
            </tbody>
          </table>
          <p>
            The debris removal expense is less than 25% of the sum of the loss
            payable plus the deductible. The sum of the loss payable and the
            debris removal expense ($49,500 + $10,000 = $59,500) is less than
            the Limit of Insurance. Therefore, the full amount of debris removal
            expense is payable in accordance with the terms of Paragraph
            <b>(3)</b>.
          </p>
          <p><b>Example 2</b></p>
          <table style="width: 100%">
            <tbody>
              <tr>
                <td>Limit of Insurance</td>
                <td>$ 90,000</td>
              </tr>
              <tr>
                <td>Amount of Deductible</td>
                <td>$ 500</td>
              </tr>
              <tr>
                <td>Amount of Loss</td>
                <td>$ 80,000</td>
              </tr>
              <tr>
                <td>Amount of Loss Payable</td>
                <td>
                  $ 79,500 <br />
                  <span>($80,000 – $500)</span>
                </td>
              </tr>
              <tr>
                <td>Debris Removal Expense</td>
                <td>$ 40,000</td>
              </tr>
              <tr>
                <td>Debris Removal Expense Payable</td>
                <td>$ 10,000</td>
              </tr>
              <tr>
                <td style="text-align: center">Basic Amount:</td>
                <td>$ 10,500</td>
              </tr>
              <tr>
                <td style="text-align: center">Additional Amount:</td>
                <td>$ 25,500</td>
              </tr>
            </tbody>
          </table>
          <p>
            The basic amount payable for debris removal expense under the terms
            of Paragraph <b>(3)</b> is calculated as follows: $80,000 ($79,500 +
            $500) x .25 = $20,000, capped at $10,500. The cap applies because
            the sum of the loss payable ($79,500) and the basic amount payable
            for debris removal expense ($10,500) cannot exceed the Limit of
            Insurance ($90,000).
          </p>
          <p>
            The additional amount payable for debris removal expense is provided
            in accordance with the terms of Paragraph <b>(4)</b>, because the
            debris removal expense ($40,000) exceeds 25% of the loss payable
            plus the deductible ($40,000 is 50% of $80,000), and because the sum
            of the loss payable and debris removal expense ($79,500 + $40,000 =
            $119,500) would exceed the Limit of Insurance ($90,000). The
            additional amount of covered debris removal expense is $25,000, the
            maximum payable under Paragraph <b>(4)</b>. Thus, the total payable
            for debris removal expense in this example is $35,500; $4,500 of the
            debris removal expense is not covered.
          </p>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ol type="a" start="2">
            <li style="padding-bottom: 10px;">
              <b>Preservation Of Property</b> <br />
              If it is necessary for you to move Covered Property from the
              described premises to preserve it from loss or damage by a Covered
              Cause of Loss, we will pay for any direct physical loss or damage
              to that property:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1)</b> While it is being moved or while temporarily stored
                  at another location; and
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(2) </b>Only if the loss or damage occurs within 30 days
                  after the property is first moved.
                </li>
              </ul>
            </li>
            <li style="padding-bottom: 10px;">
              <b>Fire Department Service Charge </b> <br />
              When the fire department is called to save or protect Covered
              Property from a Covered Cause of Loss, we will pay up to $1,000
              for service at each premises described in the Declarations, unless
              a higher limit is shown in the Declarations. Such limit is the
              most we will pay regardless of the number of responding fire
              departments or fire units, and regardless of the number or type of
              services performed. <br />
              This Additional Coverage applies to your liability for fire
              department service charges:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1)</b> Assumed by contract or agreement prior to loss; or
                </li>
                <li style="padding-bottom: 10px;"><b>(2) </b> Required by local ordinance.</li>
              </ul>
              No Deductible applies to this Additional Coverage.
            </li>
            <li style="padding-bottom: 10px;">
              <b>Pollutant Clean-up And Removal </b><br />
              <p>
                We will pay your expense to extract "pollutants" from land or
                water at the described premises if the discharge, dispersal,
                seepage, migration, release or escape of the "pollutants" is
                caused by or results from a Covered Cause of Loss that occurs
                during the policy period. The expenses will be paid only if they
                are reported to us in writing within 180 days of the date on
                which the Covered Cause of Loss occurs.
              </p>
              <p>
                This Additional Coverage does not apply to costs to test for,
                monitor or assess the existence, concentration or effects of
                "pollutants". But we will pay for testing which is performed in
                the course of extracting the "pollutants" from the land or
                water.
              </p>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 5 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <p>
                The most we will pay under this Additional Coverage for each
                described premises is $10,000 for the sum of all covered
                expenses arising out of Covered Causes of Loss occurring during
                each separate 12- month period of this policy.
              </p>
            </li>
          </ul>
          <ol type="a" start="5">
            <li style="padding-bottom: 10px;">
              <b>Increased Cost Of Construction</b>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1)</b> This Additional Coverage applies only to buildings
                  to which the Replacement Cost Optional Coverage applies.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(2)</b> In the event of damage by a Covered Cause of Loss
                  to a building that is Covered Property, we will pay the
                  increased costs incurred to comply with the minimum standards
                  of an ordinance or law in the course of repair, rebuilding or
                  replacement of damaged parts of that property, subject to the
                  limitations stated in <b>e.(3)</b> through <b>e.(9)</b> of
                  this Additional Coverage.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(3)</b> The ordinance or law referred to in <b>e.(2)</b> of
                  this Additional Coverage is an ordinance or law that regulates
                  the construction or repair of buildings or establishes zoning
                  or land use requirements at the described premises and is in
                  force at the time of loss.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(4)</b> Under this Additional Coverage, we will not pay any
                  costs due to an ordinance or law that:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(a)</b> You were required to comply with before the
                      loss, even when the building was undamaged; and
                    </li>
                    <li style="padding-bottom: 10px;"><b>(b)</b> You failed to comply with</li>
                  </ul>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(5)</b> Under this Additional Coverage, we will not pay
                  for:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(a)</b> The enforcement of or compliance with any
                      ordinance or law which requires demolition, repair,
                      replacement, reconstruction, remodeling or remediation of
                      property due to contamination by "pollutants" or due to
                      the presence, growth, proliferation, spread or any
                      activity of "fungus", wet or dry rot or bacteria; or
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(b)</b> Any costs associated with the enforcement of or
                      compliance with an ordinance or law which requires any
                      insured or others to test for, monitor, clean up, remove,
                      contain, treat, detoxify or neutralize, or in any way
                      respond to, or assess the effects of "pollutants", "fu
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <b>(6)</b> The most we will pay under this Additional Coverage,
              for each described building insured under this Coverage Form, is
              $10,000 or 5% of the Limit of Insurance applicable to that
              building, whichever is less. If a damaged building is covered
              under a blanket Limit of Insurance which applies to more than one
              building or item of property, then the most we will pay under this
              Additional Coverage, for that damaged building, is the lesser of
              $10,000 or 5% times the value of the damaged building as of the
              time of loss times the applicable Coinsurance percentage.
              <br />
              The amount payable under this Additional Coverage is additional
              insurance.
            </li>
            <li style="padding-bottom: 10px;">
              <b>(7)</b> With respect to this Additional Coverage:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(a)</b> We will not pay for the Increased Cost of
                  Construction:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(i)</b> Until the property is actually repaired or
                      replaced at the same or another premises; and
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(ii)</b> Unless the repair or replacement is made as
                      soon as reasonably possible after the loss or damage, not
                      to exceed two years. We may extend this period in writing
                      during the two years.
                    </li>
                  </ul>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(b)</b> If the building is repaired or replaced at the same
                  premises, or if you elect to rebuild at another premises, the
                  most we will pay for the Increased Cost of Construction,
                  subject to the provisions of <b>e.(6)</b> of this Additional
                  Coverage, is the increased cost of construction at the same
                  premises.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(c)</b> If the ordinance or law requires relocation to
                  another premises, the most we will pay for the Increased Cost
                  of Construction, subject to the provisions of <b>e.(6)</b> of
                  this Additional Coverage, is the increased cost of
                  construction at the new premises.
                </li>
              </ul>
            </li>
            <li style="padding-bottom: 10px;">
              <b>(8)</b> This Additional Coverage is not subject to the terms of
              the Ordinance Or Law Exclusion to the extent that such Exclusion
              would conflict with the provisions of this Additional Coverage.
            </li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 6 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(9)</b>The costs addressed in the Loss Payment and
                  Valuation Conditions and the Replacement Cost Optional
                  Coverage, in this Coverage Form, do not include the increased
                  cost attributable to enforcement of or compliance with an
                  ordinance or law. The amount payable under this Additional
                  Coverage, as stated in <b>e.(6)</b> of this Additional
                  Coverage, is not subject to such limitation.
                </li>
              </ul>
            </li>
          </ul>
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <b>f. Electronic Data</b>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1) </b>Under this Additional Coverage, electronic data has
                  the meaning described under Property Not Covered, Electronic
                  Data. This Additional Coverage does not apply to electronic
                  data which is integrated in and operates or controls the
                  building's elevator, lighting, heating, ventilation, air
                  conditioning or security system.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(2) </b>Subject to the provisions of this Additional
                  Coverage, we will pay for the cost to replace or restore
                  electronic data which has been destroyed or corrupted by a
                  Covered Cause of Loss. To the extent that electronic data is
                  not replaced or restored, the loss will be valued at the cost
                  of replacement of the media on which the electronic data was
                  stored, with blan
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(3) </b>The Covered Causes of Loss applicable to Your
                  Business Personal Property apply to this Additional Coverage,
                  Electronic Data, subject to the following:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(a)</b>
                      If the Causes Of Loss – Special Form applies, coverage
                      under this Additional Coverage, Electronic Data, is
                      limited to the "specified causes of loss" as defined in
                      that form and Collapse as set forth in that form.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(b)</b>
                      If the Causes Of Loss – Broad Form applies, coverage under
                      this Additional Coverage, Electronic Data, includes
                      Collapse as set forth in that form.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(c)</b>
                      If the Causes Of Loss form is endorsed to add a Covered
                      Cause of Loss, the additional Covered Cause of Loss does
                      not apply to the coverage provided under this Additional
                      Coverage, Electronic Data.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(d)</b>
                  The Covered Causes of Loss include a virus, harmful code or
                  similar instruction introduced into or enacted on a computer
                  system (including electronic data) or a network to which it is
                  connected, designed to damage or destroy any part of the
                  system or disrupt its normal operation. But there is no
                  coverage for loss or damage caused by or resulting from
                  manipulation of a computer system (including electronic data)
                  by any employee, including a temporary or leased employee, or
                  by an entity retained by you or for you to inspect, design,
                  install, modify, maintain, repair or replace that system.
                </li>
              </ul>
            </li>
            <li style="padding-bottom: 10px;">
              <b>(4)</b>
              The most we will pay under this Additional Coverage, Electronic
              Data, is $2,500 (unless a higher limit is shown in the
              Declarations) for all loss or damage sustained in any one policy
              year, regardless of the number of occurrences of loss or damage or
              the number of premises, locations or computer systems involved. If
              loss payment on the first occurrence does not exhaust this amount,
              then the balance is available for subsequent loss or damage
              sustained in but not after that policy year. With respect to an
              occurrence which begins in one policy year and continues or
              results in additional loss or damage in a subsequent policy
              year(s), all loss or damage is deemed to be sustained in the
              policy year in which the occurrence began.
            </li>
          </ul>
          <ol type="1" start="5">
            <li style="padding-bottom: 10px;">
              <b>Coverage Extensions </b><br />
              Except as otherwise provided, the following Extensions apply to
              property located in or on the building described in the
              Declarations or in the open (or in a vehicle) within 100 feet of
              the described premises. <br />
              If a Coinsurance percentage of 80% or more is shown in the
              Declarations, you may extend the insurance provided by this
              Coverage Part as follows:
              <ol type="a">
                <li style="padding-bottom: 10px;">
                  <b>Newly Acquired Or Constructed Property</b>
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(1) Buildings</b><br />
                      You may extend the insurance that applies to Building to
                      apply to:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px;">
                          <b>(a)</b> Your new buildings while being built on the
                          described premises; and
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 7 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(b)</b> Buildings you acquire at locations, other than the
                  described premises, intended for:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(i)</b> Similar use as the building described in the
                      Declarations; or
                    </li>
                    <li style="padding-bottom: 10px;"><b>(ii)</b> Use as a warehouse.</li>
                  </ul>
                  The most we will pay for loss or damage under this Extension
                  is $250,000 at each building.
                </li>
              </ul>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(2) Your Business Personal Property</b>
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(a)</b> If this policy covers Your Business Personal
                      Property, you may extend that insurance to apply to:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px;">
                          <b>(i)</b> Business personal property, including such
                          property that you newly acquire, at any location you
                          acquire other than at fairs, trade shows or
                          exhibitions; or
                        </li>
                        <li style="padding-bottom: 10px;">
                          <b>(ii)</b> Business personal property, including such
                          property that you newly acquire, located at your newly
                          constructed or acquired buildings at the location
                          described in the Declarations.
                        </li>
                      </ul>
                      The most we will pay for loss or damage under this
                      Extension is $100,000 at each building.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(b)</b>This Extension does not apply to:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px;">
                          <b>(i)</b>
                          Personal property of others that is temporarily in
                          your possession in the course of installing or
                          performing work on such property; or
                        </li>
                        <li style="padding-bottom: 10px;">
                          <b>(ii)</b>
                          Personal property of others that is temporarily in
                          your possession in the course of your manufacturing or
                          wholesaling activities.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(3) Period Of Coverage</b> <br />
                  With respect to insurance provided under this Coverage
                  Extension for Newly Acquired Or Constructed Property, coverage
                  will end when any of the following first occurs:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;"><b>(a)</b> This policy expires;</li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(b)</b> 30 days expire after you acquire the property or
                  begin construction of that part of the building that would
                  qualify as covered property; or
                </li>
                <li style="padding-bottom: 10px;"><b>(c)</b> You report values to us.</li>
                <p>
                  We will charge you additional premium for values reported from
                  the date you acquire the property or begin construction of
                  that part of the building that would qualify as covered
                  property.
                </p>
              </ul>
            </li>
          </ul>
          <ol type="a" start="2">
            <li style="padding-bottom: 10px;">
              <b>Personal Effects And Property Of Others</b><br />
              You may extend the insurance that applies to Your Business
              Personal Property to apply to:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1)</b> Personal effects owned by you, your officers, your
                  partners or members, your managers or your employees. This
                  Extension does not apply to loss or damage by theft.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(2)</b> Personal property of others in your care, custody
                  or control.
                </li>
              </ul>
              The most we will pay for loss or damage under this Extension is
              $2,500 at each described premises. Our payment for loss of or
              damage to personal property of others will only be for the account
              of the owner of the property.
            </li>
            <li style="padding-bottom: 10px;">
              <b>Valuable Papers And Records (Other Than Electronic Data)</b>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1)</b> You may extend the insurance that applies to Your
                  Business Personal Property to apply to the cost to replace or
                  restore the lost information on valuable papers and records
                  for which duplicates do not exist. But this Extension does not
                  apply to valuable papers and records which exist as electronic
                  data. Electronic data has the meaning described under Property
                  Not Covered, Electronic Data.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(2)</b> If the Causes Of Loss – Special Form applies,
                  coverage under this Extension is limited to the "specified
                  causes of loss" as defined in that form and Collapse as set
                  forth in that form.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(3)</b> If the Causes Of Loss – Broad Form applies,
                  coverage under this Extension includes Collapse as set forth
                  in that form.
                </li>
              </ul>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 8 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(4)</b> Under this Extension, the most we will pay to
                  replace or restore the lost information is $2,500 at each
                  described premises, unless a higher limit is shown in the
                  Declarations. Such amount is additional insurance. We will
                  also pay for the cost of blank material for reproducing the
                  records (whether or not duplicates exist) and (when there is a
                  duplicate) for the cost of labor to transcribe or copy the
                  records. The costs of blank material and labor are subject to
                  the applicable Limit of Insurance on Your Business Personal
                  Property and, therefore, coverage of such costs is not
                  additional insurance.
                </li>
              </ul>
            </li>
          </ul>
          <ol type="a" start="4">
            <li style="padding-bottom: 10px;">
              <b>Property Off-premises</b>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1)</b> You may extend the insurance provided by this
                  Coverage Form to apply to your Covered Property while it is
                  away from the described premises, if it is:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(a)</b> Temporarily at a location you do not own, lease
                      or operate;
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(b)</b> In storage at a location you lease, provided
                      the lease was executed after the beginning of the current
                      policy term; or
                    </li>
                    <li style="padding-bottom: 10px;"><b>(c)</b> At any fair, trade show or exhibition.</li>
                  </ul>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(2)</b> This Extension does not apply to property:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;"><b>(a)</b> In or on a vehicle; or</li>
                    <li style="padding-bottom: 10px;">
                      <b>(b)</b> In the care, custody or control of your
                      salespersons, unless the property is in such care, custody
                      or control at a fair, trade show or exhibition.
                    </li>
                  </ul>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(3)</b> The most we will pay for loss or damage under this
                  Extension is $10,000.
                </li>
              </ul>
            </li>
            <li style="padding-bottom: 10px;">
              <b>Outdoor Property</b><br />
              You may extend the insurance provided by this Coverage Form to
              apply to your outdoor fences, radio and television antennas
              (including satellite dishes), trees, shrubs and plants (other than
              trees, shrubs or plants which are "stock" or are part of a
              vegetated roof), including debris removal expense, caused by or
              resulting from any of the following causes of loss if they are
              Covered Causes of Loss:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;"><b>(1)</b> Fire;</li>
                <li style="padding-bottom: 10px;"><b>(2)</b> Lightning;</li>
              </ul>
            </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;"><b>(3)</b> Explosion;</li>
                <li style="padding-bottom: 10px;"><b>(4)</b> Riot or Civil Commotion; or</li>
                <li style="padding-bottom: 10px;"><b>(5)</b> Aircraft</li>
                <p>
                  The most we will pay for loss or damage under this Extension
                  is $1,000, but not more than $250 for any one tree, shrub or
                  plant. These limits apply to any one occurrence, regardless of
                  the types or number of items lost or damaged in that
                  occurrence.<br />
                  Subject to all aforementioned terms and limitations of
                  coverage, this Coverage Extension includes the expense of
                  removing from the described premises the debris of trees,
                  shrubs and plants which are the property of others.
                </p>
              </ul>
            </li>
          </ul>
          <ol type="a" start="6">
            <li style="padding-bottom: 10px;">
              <b>Non-owned Detached Trailers</b>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1)</b>
                  You may extend the insurance that applies to Your Business
                  Personal Property to apply to loss or damage to trailers that
                  you do not own, provided that:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;"><b>(a)</b> The trailer is used in your business;</li>
                    <li style="padding-bottom: 10px;">
                      <b>(b)</b> The trailer is in your care, custody or control
                      at the premises described in the Declarations; and
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(c)</b> You have a contractual responsibility to pay
                      for loss or damage to the trailer.
                    </li>
                  </ul>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(2)</b> We will not pay for any loss or damage that occurs:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(a)</b>
                      While the trailer is attached to any motor vehicle or
                      motorized conveyance, whether or not the motor vehicle or
                      motorized conveyance is in motion;
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(b)</b>
                      During hitching or unhitching operations, or when a
                      trailer becomes accidentally unhitched from a motor
                      vehicle or motorized conveyance.
                    </li>
                  </ul>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(3)</b> The most we will pay for loss or damage under this
                  Extension is $5,000, unless a higher limit is shown in the
                  Declarations.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(4)</b>
                  This insurance is excess over the amount due (whether you can
                  collect on it or not) from any other insurance covering such
                  property
                </li>
              </ul>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 9 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ol type="a" start="7">
            <li style="padding-bottom: 10px;">
              <b
                >Business Personal Property Temporarily In Portable Storage
                Units</b
              >
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1)</b> You may extend the insurance that applies to Your
                  Business Personal Property to apply to such property while
                  temporarily stored in a portable storage unit (including a
                  detached trailer) located within 100 feet of the described
                  premises.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(2)</b> If the applicable Covered Causes of Loss form or
                  endorsement contains a limitation or exclusion concerning loss
                  or damage from sand, dust, sleet, snow, ice or rain to
                  property in a structure, such limitation or exclusion also
                  applies to property in a portable storage unit.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(3)</b> Coverage under this Extension:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(a)</b> Will end 90 days after the business personal
                      property has been placed in the storage unit;
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(b)</b> Does not apply if the storage unit itself has
                      been in use at the described premises for more than 90
                      consecutive days, even if the business personal property
                      has been stored there for 90 or fewer days as of the time
                      of loss or damage.
                    </li>
                  </ul>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(4)</b> Under this Extension, the most we will pay for the
                  total of all loss or damage to business personal property is
                  $10,000 (unless a higher limit is indicated in the
                  Declarations for such Extension) regardless of the number of
                  storage units. Such limit is part of, not in addition to, the
                  applicable Limit of Insurance on Your Business Personal
                  Property. Therefore, payment under this Extension will not
                  increase the applicable Limit of Insurance on Your Business
                  Personal Property.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(5)</b> This Extension does not apply to loss or damage
                  otherwise covered under this Coverage Form or any endorsement
                  to this Coverage Form or policy, and does not apply to loss or
                  damage to the storage unit itself.
                </li>
              </ul>
            </li>
            <p>
              Each of these Extensions is additional insurance unless otherwise
              indicated. The Additional Condition, Coinsurance, does not apply
              to these Extensions.
            </p>
          </ol>
          <ol type="A" start="2">
            <li style="padding-bottom: 10px;">
              <b>Exclusions And Limitations </b> <br />
              See applicable Causes Of Loss form as shown in the Declarations.
            </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ol type="A" start="3">
            <li style="padding-bottom: 10px;">
              <b> Limits Of Insurance</b> <br />
              The most we will pay for loss or damage in any one occurrence is
              the applicable Limit Of Insurance shown in the Declarations.
              <br />
              The most we will pay for loss or damage to outdoor signs, whether
              or not the sign is attached to a building, is $2,500 per sign in
              any one occurrence.
              <br />
              The amounts of insurance stated in the following Additional
              Coverages apply in accordance with the terms of such coverages and
              are separate from the Limit(s) Of Insurance shown in the
              Declarations for any other coverage:
              <ol>
                <li style="padding-bottom: 10px;">Fire Department Service Charge;</li>
                <li style="padding-bottom: 10px;">Pollutant Clean-up And Removal;</li>
                <li style="padding-bottom: 10px;">Increased Cost Of Construction; and</li>
                <li style="padding-bottom: 10px;">Electronic Data.</li>
              </ol>
              Payments under the Preservation Of Property Additional Coverage
              will not increase the applicable Limit of Insurance.
            </li>
            <li style="padding-bottom: 10px;">
              <b>Deductible</b><br />
              In any one occurrence of loss or damage (hereinafter referred to
              as loss), we will first reduce the amount of loss if required by
              the Coinsurance Condition or the Agreed Value Optional Coverage.
              If the adjusted amount of loss is less than or equal to the
              Deductible, we will not pay for that loss. If the adjusted amount
              of loss exceeds the Deductible, we will then subtract the
              Deductible from the adjusted amount of loss and will pay the
              resulting amount or the Limit of Insurance, whichever is less.<br />
              When the occurrence involves loss to more than one item of Covered
              Property and separate Limits of Insurance apply, the losses will
              not be combined in determining application of the Deductible. But
              the Deductible will be applied only once per occurrence.
            </li>
          </ol>
          <p><b>Example 1</b></p>
          <p>(This example assumes there is no Coinsurance penalty.)</p>
          <table style="width: 100%">
            <tbody>
              <tr>
                <td>Deductible:</td>
                <td>$ 250</td>
              </tr>
              <tr>
                <td>Limit of Insurance – Building 1:</td>
                <td>$ 60,000</td>
              </tr>
              <tr>
                <td>Limit of Insurance – Building 2:</td>
                <td>$ 80,000</td>
              </tr>
              <tr>
                <td>Loss to Building 1:</td>
                <td>$ 60,100</td>
              </tr>
              <tr>
                <td>Loss to Building 2:</td>
                <td>$ 90,100</td>
              </tr>
            </tbody>
          </table>
          <p>
            The amount of loss to Building 1 ($60,100) is less than the sum
            ($60,250) of the Limit of Insurance applicable to Building 1 plus
            the Deductible.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 10 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <p>
            The Deductible will be subtracted from the amount of loss in
            calculating the loss payable for Building 1:
          </p>
          <p class="mb-0">$ 60,100</p>
          <p
            class="mb-0"
            style="
              width: 10%;
              padding-left: 20px;
              border-bottom: 1px solid black;
            "
          >
            - 250
          </p>
          <p class="mb-0">$ 59,850 Loss Payable - Building 1</p>
          <p>
            The Deductible applies once per occurrence and therefore is not
            subtracted in determining the amount of loss payable for Building 2.
            Loss payable for Building 2 is the Limit of Insurance of $80,000.
          </p>
          <p class="mb-0">Total amount of loss payable:</p>
          <p>$59,850 + $80,000 = $139,850</p>
          <p><b>Example 2</b></p>
          <p>(This example, too, assumes there is no Coinsurance penalty.)</p>
          <p>
            The Deductible and Limits of Insurance are the same as those in
            Example 1.
          </p>
          <table style="width: 100%">
            <tbody>
              <tr>
                <td>Loss to Building 1:</td>
                <td>$ 70,000</td>
              </tr>
              <tr>
                <td>(Exceeds Limit of Insurance plus Deductible)</td>
              </tr>
              <tr>
                <td>Loss to Building 2:</td>
                <td>$ 90,000</td>
              </tr>
              <tr>
                <td>(Exceeds Limit of Insurance plus Deductible)</td>
              </tr>
              <tr>
                <td>Loss Payable – Building 1:</td>
                <td>$ 60,000</td>
              </tr>
              <tr>
                <td>(Limit of Insurance)</td>
              </tr>
              <tr>
                <td>Loss Payable – Building 2:</td>
                <td>$ 80,000</td>
              </tr>
              <tr>
                <td>(Limit of Insurance)</td>
              </tr>
              <tr>
                <td>Total amount of loss payable:</td>
                <td>$ 140,000</td>
              </tr>
            </tbody>
          </table>
          <ol type="A" start="5">
            <li style="padding-bottom: 10px;">
              <b>Loss Conditions</b><br />
              The following conditions apply in addition to the Common Policy
              Conditions and the Commercial Property Conditions:
              <ol>
                <li style="padding-bottom: 10px;">
                  <b>Abandonment</b><br />
                  There can be no abandonment of any property to us.
                </li>
                <li style="padding-bottom: 10px;">
                  <b>Appraisal</b><br />
                  If we and you disagree on the value of the property or the
                  amount of loss, either may make written demand for an
                  appraisal of the loss. In this event, each party will select a
                  competent and impartial appraiser. The two appraisers will
                  select an umpire. If they cannot agree, either may request
                  that selection be made by a judge of a court having
                  jurisdiction. The appraisers will state separately the value
                  of the property and amount of loss. If they fail to agree,
                  they will submit their differences to the umpire. A decision
                  agreed to by any two will be binding. Each party will:
                  <ol type="a">
                    <li style="padding-bottom: 10px;">Pay its chosen appraiser; and</li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>b. </b>Bear the other expenses of the appraisal and umpire
                  equally.
                </li>
                <p>
                  If there is an appraisal, we will still retain our right to
                  deny the claim.
                </p>
              </ul>
            </li>
          </ul>
          <ol type="1" start="3">
            <li style="padding-bottom: 10px;">
              <b>Duties In The Event Of Loss Or Damage</b>
              <ol type="a">
                <li style="padding-bottom: 10px;">
                  You must see that the following are done in the event of loss
                  or damage to Covered Property:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(1)</b> Notify the police if a law may have been
                      broken.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(2)</b> Give us prompt notice of the loss or damage.
                      Include a description of the property involved.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(3)</b>
                      As soon as possible, give us a description of how, when
                      and where the loss or damage occurred.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(4)</b>
                      Take all reasonable steps to protect the Covered Property
                      from further damage, and keep a record of your expenses
                      necessary to protect the Covered Property, for
                      consideration in the settlement of the claim. This will
                      not increase the Limit of Insurance. However, we will not
                      pay for any subsequent loss or damage resulting from a
                      cause of loss that is not a Covered Cause of Loss. Also,
                      if feasible, set the damaged property aside and in the
                      best possible order for examination.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(5)</b>
                      At our request, give us complete inventories of the
                      damaged and undamaged property. Include quantities, costs,
                      values and amount of loss claimed.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(6)</b> As often as may be reasonably required, permit
                      us to inspect the property proving the loss or damage and
                      examine your books and records. <br />
                      Also, permit us to take samples of damaged and undamaged
                      property for inspection, testing and analysis, and permit
                      us to make copies from your books and records.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(7)</b>
                      Send us a signed, sworn proof of loss containing the
                      information we request to investigate the claim. You must
                      do this within 60 days after our request. We will supply
                      you with the necessary forms.
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(8)</b>
                      Cooperate with us in the investigation or settlement of
                      the claim.
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 11 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ol type="a" start="2">
            <li style="padding-bottom: 10px;">
              We may examine any insured under oath, while not in the presence
              of any other insured and at such times as may be reasonably
              required, about any matter relating to this insurance or the
              claim, including an insured's books and records. In the event of
              an examination, an insured's answers must be signed.
            </li>
          </ol>
          <ol start="4">
            <li style="padding-bottom: 10px;">
              <b>Loss Payment</b>
              <ol type="a">
                <li style="padding-bottom: 10px;">
                  In the event of loss or damage covered by this Coverage Form,
                  at our option, we will either:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(1) </b>Pay the value of lost or damaged property;
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(2) </b>Pay the cost of repairing or replacing the lost
                      or damaged property, subject to b. below;
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(3) </b>Take all or any part of the property at an
                      agreed or appraised value; or
                    </li>
                    <li style="padding-bottom: 10px;">
                      <b>(4) </b>Repair, rebuild or replace the property with
                      other property of like kind and quality, subject to
                      <b>b.</b> below.
                    </li>
                  </ul>
                  We will determine the value of lost or damaged property, or
                  the cost of its repair or replacement, in accordance with the
                  applicable terms of the Valuation Condition in this Coverage
                  Form or any applicable provision which amends or supersedes
                  the Valuation Condition.
                </li>
                <li style="padding-bottom: 10px;">
                  The cost to repair, rebuild or replace does not include the
                  increased cost attributable to enforcement of or compliance
                  with any ordinance or law regulating the construction, use or
                  repair of any property.
                </li>
                <li style="padding-bottom: 10px;">
                  We will give notice of our intentions within 30 days after we
                  receive the sworn proof of loss.
                </li>
                <li style="padding-bottom: 10px;">
                  We will not pay you more than your financial interest in the
                  Covered Property.
                </li>
                <li style="padding-bottom: 10px;">
                  We may adjust losses with the owners of lost or damaged
                  property if other than you. If we pay the owners, such
                  payments will satisfy your claims against us for the owners'
                  property. We will not pay the owners more than their financial
                  interest in the Covered Property.
                </li>
                <li style="padding-bottom: 10px;">
                  We may elect to defend you against suits arising from claims
                  of owners of property. We will do this at our expense.
                </li>
              </ol>
            </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ol type="a" start="7">
                <li style="padding-bottom: 10px;">
                  We will pay for covered loss or damage to Covered Property
                  within 30 days after we receive the sworn proof of loss, if
                  you have complied with all of the terms of this Coverage Part,
                  and:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;">
                      <b>(1) </b>We have reached agreement with you on the
                      amount of loss; or
                    </li>
                    <li style="padding-bottom: 10px;"><b>(2) </b>An appraisal award has been made.</li>
                  </ul>
                  If you name an insurance trustee, we will adjust losses with
                  you, but we will pay the insurance trustee. If we pay the
                  trustee, the payments will satisfy your claims against us.
                </li>
                <li style="padding-bottom: 10px;">
                  A party wall is a wall that separates and is common to
                  adjoining buildings that are owned by different parties. In
                  settling covered losses involving a party wall, we will pay a
                  proportion of the loss to the party wall based on your
                  interest in the wall in proportion to the interest of the
                  owner of the adjoining building. However, if you elect to
                  repair or replace your building and the owner of the adjoining
                  building elects not to repair or replace that building, we
                  will pay you the full value of the loss to the party wall,
                  subject to all applicable policy provisions including Limits
                  of Insurance, the Valuation and Coinsurance Conditions and all
                  other provisions of this Loss Payment Condition. Our payment
                  under the provisions of this paragraph does not alter any
                  right of subrogation we may have against any entity, including
                  the owner or insurer of the adjoining building, and does not
                  alter the terms of the Transfer Of Rights Of Recovery Against
                  Others To Us Condition in this policy.
                </li>
              </ol>
            </li>
          </ul>
          <ol start="5">
            <li style="padding-bottom: 10px;">
              <b>Recovered Property</b><br />
              If either you or we recover any property after loss settlement,
              that party must give the other prompt notice. At your option, the
              property will be returned to you. You must then return to us the
              amount we paid to you for the property. We will pay recovery
              expenses and the expenses to repair the recovered property,
              subject to the Limit of Insurance.
            </li>
            <li style="padding-bottom: 10px;">
              <b> Unit-owner's Insurance </b><br />
              A unit-owner may have other insurance covering the same property
              as this insurance. This insurance is intended to be primary and
              not to contribute with such other insurance.
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 12 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ol start="7">
            <li style="padding-bottom: 10px;">
              <b>Vacancy</b>
              <ol type="a">
                <li style="padding-bottom: 10px;">
                  <b>Description Of Terms</b>
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 5px;">
                      <b>(1)</b> As used in this Vacancy Condition, the term
                      building and the term vacant have the meanings set forth
                      in <b>(1)(a)</b> and <b>(1)(b)</b> below:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 5px;">
                          <b>(a)</b>
                          When this policy is issued to a tenant, and with
                          respect to that tenant's interest in Covered Property,
                          building means the unit or suite rented or leased to
                          the tenant. Such building is vacant when it does not
                          contain enough business personal property to conduct
                          customary operations.
                        </li>
                        <li style="padding-bottom: 5px;">
                          <b>(b)</b>
                          When this policy is issued to the owner or general
                          lessee of a building, building means the entire
                          building. Such building is vacant unless at least 31%
                          of its total square footage is:
                          <ul style="list-style-type: none">
                            <li style="padding-bottom: 5px;">
                              <b>(i)</b> Rented to a lessee or sublessee and
                              used by the lessee or sublessee to conduct its
                              customary operations; and/or
                            </li>
                            <li style="padding-bottom: 5px;">
                              <b>(ii)</b> Used by the building owner to conduct
                              customary operations.
                            </li>
                          </ul>
                        </li>
                        <b>(2)</b
                        >Buildings under construction or renovation are not
                        considered vacant.
                      </ul>
                      <ol type="a" start="2">
                        <li style="padding-bottom: 5px;">
                          <b> Vacancy Provisions </b><br />
                          If the building where loss or damage occurs has been
                          vacant for more than 60 consecutive days before that
                          loss or damage occurs:
                          <ul style="list-style-type: none">
                            <li style="padding-bottom: 5px;">
                              <b>(1)</b>
                              We will not pay for any loss or damage caused by
                              any of the following, even if they are Covered
                              Causes of Loss:

                              <ul style="list-style-type: none">
                                <li style="padding-bottom: 5px;"><b>(a)</b> Vandalism;</li>
                                <li style="padding-bottom: 5px;">
                                  <b>(b)</b> Sprinkler leakage, unless you have
                                  protected the system against freezing;
                                </li>
                                <li style="padding-bottom: 5px;"><b>(c)</b> Building glass breakage;</li>
                                <li style="padding-bottom: 5px;"><b>(d)</b> Water damage;</li>
                                <li style="padding-bottom: 5px;"><b>(e)</b> Theft; or</li>
                                <li style="padding-bottom: 5px;"><b>(f)</b> Attempted theft.</li>
                              </ul>
                            </li>
                            <li style="padding-bottom: 5px;">
                              <b>(2)</b> With respect to Covered Causes of Loss
                              other than those listed in <b>b.(1)(a)</b> through
                              <b>b.(1)(f)</b> above, we will reduce the amount
                              we would otherwise pay for the loss or damage by
                              15%.
                            </li>
                          </ul>
                        </li>
                      </ol>
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ol start="8">
                <li style="padding-bottom: 10px;">
                  <b>Valuation</b>
                  <br />
                  We will determine the value of Covered Property in the event
                  of loss or damage as follows:
                  <ol type="a">
                    <li style="padding-bottom: 10px;">
                      At actual cash value as of the time of loss or damage,
                      except as provided in <b>b.</b> and <b>c.</b> below.
                    </li>
                    <li style="padding-bottom: 10px;">
                      If the Limit of Insurance for Building satisfies the
                      Additional Condition, Coinsurance, and the cost to repair
                      or replace the damaged building property is $2,500 or
                      less, we will pay the cost of building repairs or
                      replacement. <br />
                      The cost of building repairs or replacement does not
                      include the increased cost attributable to enforcement of
                      or compliance with any ordinance or law regulating the
                      construction, use or repair of any property. However, the
                      following property will be valued at the actual cash
                      value, even when attached to the building:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px;"><b>(1) </b>Awnings or floor coverings;</li>
                        <li style="padding-bottom: 10px;">
                          <b>(2) </b> Appliances for refrigerating, ventilating,
                          cooking, dishwashing or laundering; or
                        </li>
                        <li style="padding-bottom: 10px;"><b>(3) </b>Outdoor equipment or furniture.</li>
                      </ul>
                    </li>
                    <li style="padding-bottom: 10px;">
                      Glass at the cost of replacement with safety-glazing
                      material if required by law.
                    </li>
                  </ol>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>Waiver Of Rights Of Recovery </b><br />
                  We waive our rights to recover payment from any unit-owner of
                  the condominium that is shown in the Declarations.
                </li>
              </ol>
            </li>
          </ul>
          <ol type="A" start="6">
            <li style="padding-bottom: 10px;">
              <b>Additional Conditions</b>
              <br />
              The following conditions apply in addition to the Common Policy
              Conditions and the Commercial Property Conditions:
              <ol>
                <li style="padding-bottom: 10px;">
                  <b>Coinsurance </b><br />
                  If a Coinsurance percentage is shown in the Declarations, the
                  following condition applies:
                  <ol type="a">
                    <li style="padding-bottom: 10px;">
                      We will not pay the full amount of any loss if the value
                      of Covered Property at the time of loss times the
                      Coinsurance percentage shown for it in the Declarations is
                      greater than the Limit of Insurance for the property.
                      <br />
                      Instead, we will determine the most we will pay using the
                      following steps:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px;">
                          <b>(1)</b>Multiply the value of Covered Property at
                          the time of loss by the Coinsurance percentage;
                        </li>
                        <li style="padding-bottom: 10px;">
                          <b>(2)</b>Divide the Limit of Insurance of the
                          property by the figure determined in Step
                          <b>(1);</b>
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 13 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(3) </b>Multiply the total amount of loss, before the
                  application of any deductible, by the figure determined in
                  Step <b>(2);</b> and
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(4) </b>Subtract the deductible from the figure determined
                  in Step <b>(3).</b>
                </li>
              </ul>
              We will pay the amount determined in Step
              <b>(4)</b> or the Limit of Insurance, whichever is less. For the
              remainder, you will either have to rely on other insurance or
              absorb the loss yourself.
            </li>
          </ul>
          <p><b>Example 1 (Underinsurance)</b></p>
          <table>
            <tbody>
              <tr>
                <td>When:</td>
                <td>The value of the property is:</td>
                <td>$ 250,000</td>
              </tr>
              <tr>
                <td></td>
                <td>The Coinsurance percentage for it is:</td>
                <td>80%</td>
              </tr>
              <tr>
                <td></td>
                <td>The Limit of Insurance for it is:</td>
                <td>$100,000</td>
              </tr>
              <tr>
                <td></td>
                <td>The Deductible is:</td>
                <td>$250</td>
              </tr>
              <tr>
                <td></td>
                <td>The amount of loss is:</td>
                <td>$40,000</td>
              </tr>
            </tbody>
          </table>
          <table>
            <tbody>
              <tr>
                <td>Step <b>(1):</b></td>
                <td>
                  $250,000 x 80% = $200,000<br />
                  (the minimum amount of insurance to meet your Coinsurance
                  requirements)
                </td>
              </tr>
              <tr>
                <td>Step <b>(2):</b></td>
                <td>$100,000 ÷ $200,000 = .50</td>
              </tr>
              <tr>
                <td>Step <b>(3):</b></td>
                <td>$40,000 x .50 = $20,000</td>
              </tr>
              <tr>
                <td>Step <b>(4):</b></td>
                <td>$20,000 - $250 = $19,750</td>
              </tr>
            </tbody>
          </table>
          <p>
            We will pay no more than $19,750. The remaining $20,250 is not
            covered.
          </p>
          <p><b>Example 2 (Adequate Insurance)</b></p>
          <table>
            <tbody>
              <tr>
                <td>When:</td>
                <td>The value of the property is:</td>
                <td>$ 250,000</td>
              </tr>
              <tr>
                <td></td>
                <td>The Coinsurance percentage for it is:</td>
                <td>80%</td>
              </tr>
              <tr>
                <td></td>
                <td>The Limit of Insurance for it is:</td>
                <td>$200,000</td>
              </tr>
              <tr>
                <td></td>
                <td>The Deductible is:</td>
                <td>$250</td>
              </tr>
              <tr>
                <td></td>
                <td>The amount of loss is:</td>
                <td>$40,000</td>
              </tr>
            </tbody>
          </table>
          <p>
            The minimum amount of insurance to meet your Coinsurance requirement
            is $200,000 ($250,000 x 80%). Therefore, the Limit of Insurance in
            this example is adequate, and no penalty applies. We will pay no
            more than $39,750 ($40,000 amount of loss minus the deductible of
            $250).
          </p>
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  b. If one Limit of Insurance applies to two or more separate
                  items, this condition will apply to the total of all property
                  to which the limit applies.
                </li>
              </ul>
            </li>
          </ul>
        </td>

        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <p><b>Example 3</b></p>
          <table>
            <tbody>
              <tr>
                <td>When:</td>
                <td>The value of the property is:</td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td>Building at Location 1:</td>
                <td>$ 75,000</td>
              </tr>
              <tr>
                <td></td>
                <td>Building at Location 2:</td>
                <td>$ 100,000</td>
              </tr>
              <tr>
                <td></td>
                <td>Personal Property at Location 2:</td>
                <td>$ 75,000</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>$ 250,000</td>
              </tr>
            </tbody>
          </table>

          <table>
            <tbody>
              <tr>
                <td></td>
                <td>The Coinsurance percentage for it is:</td>
                <td>90%</td>
              </tr>
              <tr>
                <td style="width: 7.5%"></td>
                <td style="width: 40%">
                  The Limit of Insurance for Buildings and Personal Property at
                  Locations 1 and 2 is:
                </td>
                <td>$ 180,000</td>
              </tr>
              <tr>
                <td></td>
                <td>The Deductible is:</td>
                <td>$ 1,000</td>
              </tr>
              <tr>
                <td></td>
                <td>The amount of loss is:</td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td>Building at Location 2:</td>
                <td>$ 30,000</td>
              </tr>
              <tr>
                <td></td>
                <td>Personal Property at Location 2:</td>
                <td>$ 20,000</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>$ 50,000</td>
              </tr>
            </tbody>
          </table>

          <table style="width: 100%">
            <tbody>
              <tr>
                <td style="width: 20%; vertical-align: top">
                  Step <b>(1):</b>
                </td>
                <td>
                  $250,000 x 90% = $225,000<br />
                  (the minimum amount of insurance to meet your Coinsurance
                  requirements and to avoid the penalty shown below)
                </td>
              </tr>
              <tr>
                <td>Step <b>(2):</b></td>
                <td>$180,000 ÷ $225,000 = .80</td>
              </tr>
              <tr>
                <td>Step <b>(3):</b></td>
                <td>$50,000 x .80 = $40,000</td>
              </tr>
              <tr>
                <td>Step <b>(4):</b></td>
                <td>$40,000 - $1,000 = $39,000</td>
              </tr>
            </tbody>
          </table>
          <p>
            We will pay no more than $39,000. The remaining $11,000 is not
            covered.
          </p>
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ol start="2">
                <li style="padding-bottom: 10px;">
                  <b>Mortgageholders</b>
                  <ol type="a">
                    <li style="padding-bottom: 10px;">The term mortgageholder includes trustee.</li>
                    <li style="padding-bottom: 10px;">
                      We will pay for covered loss of or damage to buildings or
                      structures to each mortgageholder shown in the
                      Declarations in their order of precedence, as interests
                      may appear.
                    </li>
                    <li style="padding-bottom: 10px;">
                      The mortgageholder has the right to receive loss payment
                      even if the mortgageholder has started foreclosure or
                      similar action on the building or structure.
                    </li>
                    <li style="padding-bottom: 10px;">
                      If we deny your claim because of your acts or because you
                      have failed to comply with the terms of this Coverage
                      Part, the mortgageholder will still have the right to
                      receive loss payment if the mortgageholder:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px;">
                          <b>(1) </b>Pays any premium due under this Coverage
                          Part at our request if you have failed to do so;
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 14 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 5px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 5px;">
                  <b>(2) </b>Submits a signed, sworn proof of loss within 60
                  days after receiving notice from us of your failure to do so;
                  and
                </li>
                <li style="padding-bottom: 5px;">
                  <b>(3) </b>Has notified us of any change in ownership,
                  occupancy or substantial change in risk known to the
                  mortgageholder.
                </li>
                All of the terms of this Coverage Part will then apply directly
                to the mortgageholder.
              </ul>
            </li>
            <ol type="a" start="5">
              <li style="padding-bottom: 5px;">
                If we pay the mortgageholder for any loss or damage and deny
                payment to you because of your acts or because you have failed
                to comply with the terms of this Coverage Part:
                <ul style="list-style-type: none">
                  <li style="padding-bottom: 5px;">
                    <b>(1) </b>The mortgageholder's rights under the mortgage
                    will be transferred to us to the extent of the amount we
                    pay; and
                  </li>
                  <li style="padding-bottom: 5px;">
                    <b>(2) </b>The mortgageholder's right to recover the full
                    amount of the mortgageholder's claim will not be impaired.
                  </li>
                </ul>
                At our option, we may pay to the mortgageholder the whole
                principal on the mortgage plus any accrued interest. In this
                event, your mortgage and note will be transferred to us and you
                will pay your remaining mortgage debt to us.
              </li>
              <li style="padding-bottom: 5px;">
                If we cancel this policy, we will give written notice to the
                mortgageholder at least:

                <ul style="list-style-type: none">
                  <li style="padding-bottom: 5px;">
                    <b>(1) </b>10 days before the effective date of cancellation
                    if we cancel for your nonpayment of premium; or
                  </li>
                  <li style="padding-bottom: 5px;">
                    <b>(2) </b>30 days before the effective date of cancellation
                    if we cancel for any other reason.
                  </li>
                </ul>
              </li>
              <li style="padding-bottom: 5px;">
                If we elect not to renew this policy, we will give written
                notice to the mortgageholder at least 10 days before the
                expiration date of this policy.
              </li>
            </ol>
          </ul>
          <ol type="A" start="7">
            <li style="padding-bottom: 5px;;">
              <b>Optional Coverages</b>
              <br />
              If shown as applicable in the Declarations, the following Optional
              Coverages apply separately to each item:
              <ol>
                <li style="padding-bottom: 5px;">
                  <b>Agreed Value</b>
                  <ol type="a">
                    <li style="padding-bottom: 5px;">
                      The Additional Condition, Coinsurance, does not apply to
                      Covered Property to which this Optional Coverage applies.
                      We will pay no more for loss of or damage to that property
                      than the proportion that the Limit of Insurance under this
                      Coverage Part for the property bears to the Agreed Value
                      shown for it in the Declarations.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <ol type="a" start="2">
                    <li style="padding-bottom: 5px;">
                      If the expiration date for this Optional Coverage shown in
                      the Declarations is not extended, the Additional
                      Condition, Coinsurance, is reinstated and this Optional
                      Coverage expires.
                    </li>
                    <li style="padding-bottom: 5px;">
                      The terms of this Optional Coverage apply only to loss or
                      damage that occurs:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 5px;">
                          <b>(1) </b>On or after the effective date of this
                          Optional Coverage; and
                        </li>
                        <li style="padding-bottom: 5px;">
                          <b>(2) </b> Before the Agreed Value expiration date
                          shown in the Declarations or the policy expiration
                          date, whichever occurs first.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
              </ul>
            </li>
          </ul>
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ol start="2">
                <li style="padding-bottom: 10px;">
                  <b>Inflation Guard </b>
                  <ol type="a">
                    <li style="padding-bottom: 5px;">
                      The Limit of Insurance for property to which this Optional
                      Coverage applies will automatically increase by the annual
                      percentage shown in the Declarations.
                    </li>
                    <li style="padding-bottom: 5px;">
                      The amount of increase will be:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 5px;">
                          <b>(1) </b>The Limit of Insurance that applied on the
                          most recent of the policy inception date, the policy
                          anniversary date, or any other policy change amending
                          the Limit of Insurance, times
                        </li>
                        <li style="padding-bottom: 5px;">
                          <b>(2) </b>
                          The percentage of annual increase shown in the
                          Declarations, expressed as a decimal (example: 8% is
                          .08), times
                        </li>
                        <li style="padding-bottom: 5px;">
                          <b>(3) </b>The number of days since the beginning of
                          the current policy year or the effective date of the
                          most recent policy change amending the Limit of
                          Insurance, divided by 365.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
                <p><b>Example</b></p>
                <table>
                  <tbody>
                    <tr>
                      <td>If:</td>
                      <td>The applicable Limit of Insurance is:</td>
                      <td>$ 100,000</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>The annual percentage increase is:</td>
                      <td>8%</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        The number of days since the beginning of the policy
                        year (or last policy change) is:
                      </td>
                      <td>146</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        The amount of increase is: <br />
                        $100,000 x .08 x 146 ÷ 365 =
                      </td>
                      <td>$ 3,200</td>
                    </tr>
                  </tbody>
                </table>
                <li style="padding-bottom: 5px;">
                  <b>Replacement Cost </b>
                  <ol type="a">
                    <li style="padding-bottom: 5px;">
                      Replacement Cost (without deduction for depreciation)
                      replaces Actual Cash Value in the Valuation Loss Condition
                      of this Coverage Form.
                    </li>
                    <li style="padding-bottom:5px;">
                      This Optional Coverage does not apply to:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 5px;"><b>(1) </b>Personal property of others;</li>
                        <li style="padding-bottom: 5px;">
                          <b>(2) </b>
                          Contents of a residence;
                        </li>
                        <li style="padding-bottom: 5px;">
                          <b>(3) </b>Works of art, antiques or rare articles,
                          including etchings, pictures, statuary, marbles,
                          bronzes, porcelains and bric-a-brac.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 15 -->
<div class="pdf-page app-cp-00-17-10-12">
  <table style="width: 100%" class="font-small">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  Under the terms of this Replacement Cost Optional Coverage,
                  personal property owned indivisibly by all unit-owners, and
                  the property covered under Paragraph A.1.a.(6) of this
                  Coverage Form, are not considered to be the personal property
                  of others.
                </li>
              </ul>
            </li>
          </ul>
          <ol type="a" start="3">
            <li style="padding-bottom: 10px;">
              You may make a claim for loss or damage covered by this insurance
              on an actual cash value basis instead of on a replacement cost
              basis. In the event you elect to have loss or damage settled on an
              actual cash value basis, you may still make a claim for the
              additional coverage this Optional Coverage provides if you notify
              us of your intent to do so within 180 days after the loss or
              damage.
            </li>
            <li style="padding-bottom: 10px;">
              We will not pay on a replacement cost basis for any loss or
              damage:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1) </b>Until the lost or damaged property is actually
                  repaired or replaced; and
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(2) </b>Unless the repair or replacement is made as soon as
                  reasonably possible after the loss or damage.
                </li>
              </ul>
            </li>
            <li style="padding-bottom: 10px;">
              We will not pay more for loss or damage on a replacement cost
              basis than the least of
              <b>(1), (2)</b> or <b>(3),</b> subject to <b>f.</b> below:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <b>(1) </b>The Limit of Insurance applicable to the lost or
                  damaged property;
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(2) </b> The cost to replace the lost or damaged property
                  with other property:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px;"><b>(a) </b>Of comparable material and quality; and</li>
                    <li style="padding-bottom: 10px;"><b>(b) </b>Used for the same purpose; or</li>
                  </ul>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>(3) </b>The amount actually spent that is necessary to
                  repair or replace the lost or damaged property.
                </li>
              </ul>
              If a building is rebuilt at a new premises, the cost described in
              <b>e.(2)</b> above is limited to the cost which would have been
              incurred if the building had been rebuilt at the original premises
            </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px;">
                  <ol type="a" start="6">
                    <li style="padding-bottom: 10px;">
                      The cost of repair or replacement does not include the
                      increased cost attributable to enforcement of or
                      compliance with any ordinance or law regulating the
                      construction, use or repair of any property.
                    </li>
                  </ol>
                </li>
              </ul>
            </li>
          </ul>
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px;">
              <ol start="4">
                <li style="padding-bottom: 10px;">
                  <b
                    >Extension Of Replacement Cost To Personal Property Of
                    Others</b
                  >
                  <ol type="a">
                    <li style="padding-bottom: 10px;">
                      If the Replacement Cost Optional Coverage is shown as
                      applicable in the Declarations, then this Extension may
                      also be shown as applicable. If the Declarations show this
                      Extension as applicable, then Paragraph
                      <b>3.b.(1)</b> of the Replacement Cost Optional Coverage
                      is deleted and all other provisions of the Replacement
                      Cost Optional Coverage apply to replacement cost on
                      personal property of others
                    </li>
                    <li style="padding-bottom: 10px;">
                      With respect to replacement cost on the personal property
                      of others, the following limitation applies:<br />
                      If an item(s) of personal property of others is subject to
                      a written contract which governs your liability for loss
                      or damage to that item(s), then valuation of that item(s)
                      will be based on the amount for which you are liable under
                      such contract, but not to exceed the lesser of the
                      replacement cost of the property or the applicable Limit
                      of Insurance
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ul>
          <ol type="A" start="8">
            <li style="padding-bottom: 10px;">
              <b>Definitions </b>
              <ol>
                <li style="padding-bottom: 10px;">
                  "Fungus" means any type or form of fungus, including mold or
                  mildew, and any mycotoxins, spores, scents or by-products
                  produced or released by fungi.
                </li>
                <li style="padding-bottom: 10px;">
                  "Pollutants" means any solid, liquid, gaseous or thermal
                  irritant or contaminant, including smoke, vapor, soot, fumes,
                  acids, alkalis, chemicals and waste. Waste includes materials
                  to be recycled, reconditioned or reclaimed.
                </li>
                <li style="padding-bottom: 10px;">
                  "Stock" means merchandise held in storage or for sale, raw
                  materials and in-process or finished goods, including supplies
                  used in their packing or shipping.
                </li>
              </ol>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>
